import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=309bea8b&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=ts"
export * from "./HomeNews.vue?vue&type=script&lang=ts"
import style0 from "./HomeNews.vue?vue&type=style&index=0&id=309bea8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309bea8b",
  null
  
)

export default component.exports